import React from "react";

const Print = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6 7V5a.6.6 0 0 0-.503-.592L16 4.4H8a.6.6 0 0 0-.592.503L7.4 5v2h9.2zm.4 8.4H7a.6.6 0 0 0-.592.503L6.4 16v3a.6.6 0 0 0 .503.592L7 19.6h10a.6.6 0 0 0 .592-.503L17.6 19v-3a.6.6 0 0 0-.503-.592L17 15.4zm2 2.2.146-.007a1.6 1.6 0 0 0 1.447-1.447L20.6 16v-6a1.6 1.6 0 0 0-1.454-1.593L19 8.4H5a1.6 1.6 0 0 0-1.593 1.454L3.4 10v6a1.6 1.6 0 0 0 1.454 1.593L5 17.6V16a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1.6zM17 21H7a2 2 0 0 1-2-2 3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h1V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3 2 2 0 0 1-2 2z" fill="#AAA2AA" fillRule="nonzero" />
  </svg>


);

export default Print;
